import { createPortal } from "react-dom";

import { TableSettingsDialog } from "../../../features/context-menu/table-settings/table-settings-dialog.js";
import { SettingsUser } from "../../../features/settings-user/settings-user.js";
import { useLayoutStore } from "../../../store/layout.store.js";
import { AddNewBoardModal } from "./add-new-board-modal.jsx";
import { InactivityWarningModal } from "./inactivity-warning-modal.jsx";
import { InfoModal } from "./info-modal.jsx";
import { InviteModal } from "./invite-modal.jsx";
import { KickedForInactivityModal } from "./kicked-for-inactivity-modal.jsx";
import { OutdatedOfficeModal } from "./outdated-office-modal.jsx";
import { RequestAudioPermissionsModal } from "./request-audio-permissions-modal.jsx";
import { SidebarAppWarningModal } from "./sidebar-app-warning-modal.jsx";
import { SurveyModal } from "./survey-modal.jsx";

// Lint exception: Modal components have different prop types
const MODAL_REGISTRY: Record<string, any> = {
  audio_permissions: RequestAudioPermissionsModal,
  inactivity_warning: InactivityWarningModal,
  info: InfoModal,
  invite: InviteModal,
  kicked_for_inactivity: KickedForInactivityModal,
  new_board: AddNewBoardModal,
  outdated_office: OutdatedOfficeModal,
  "settings-user": SettingsUser,
  sidebar_app_warning: SidebarAppWarningModal,
  survey: SurveyModal,
  table_settings: TableSettingsDialog,
};

export const ModalRenderer = () => {
  const { modalVariant, modalProps, hideModal } = useLayoutStore();
  const shouldBlockHover =
    modalVariant === "settings-user" || modalVariant === "invite";

  const ModalComponent = modalVariant ? MODAL_REGISTRY[modalVariant] : null;

  if (!ModalComponent) {
    return null;
  }

  const rootElement = document.querySelector("#root");
  if (!rootElement) {
    return null;
  }

  const componentProps = { ...modalProps, onClose: hideModal };

  return createPortal(
    <>
      <div
        className="fixed inset-0 bg-black/50"
        data-blocks-hover={shouldBlockHover ? "true" : undefined}
      />
      <div
        className="fixed inset-0 flex items-center justify-center"
        data-blocks-hover={shouldBlockHover ? "true" : undefined}
      >
        <ModalComponent {...componentProps} />
      </div>
    </>,
    rootElement
  );
};
